import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/Button/Button'

const MakeThisMyStoreButton = ({
  className,
  handleSetMyLocationClick,
  disabled,
  ...props
}) =>
  <Button
    { ...props }
    className={ className }
    disabled={ disabled }
    onClick={ handleSetMyLocationClick } />

export default MakeThisMyStoreButton

MakeThisMyStoreButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleSetMyLocationClick: PropTypes.func
}
